import styled from "@emotion/styled"
import { breakPoints } from "../config/theme"

export const Title = styled.h1`
  font-family: Arial, Roboto, sans-serif;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: 0.02em;
  min-height: 72px;

  @media only screen and (max-width: ${breakPoints.mobile}) {
    font-size: 18px;
    line-height: 26px;
    min-height: 104px;
  }
`
